import { GeoPoint } from '../../location/types';
import { EsriMapEntityTypeEnum, MapView, FeatureLayer } from '../../esri/types';
import { ENTITY_TYPE_TO_FEATURE_LAYER_KEY_MAP } from '../../esri/constants';
import { Graphic } from '../../esri/constructors';

const isMapCenterAt = (mapView?: MapView, actualCenter?: GeoPoint): boolean => {
    if (!mapView || !actualCenter) {
        return false;
    }
    const currentMapCenterLat = mapView.center.latitude?.toFixed(6);
    const currentMapCenterLng = mapView.center.longitude?.toFixed(6);

    const actualLat = actualCenter.latitude?.toFixed(6);
    const actualLng = actualCenter.longitude?.toFixed(6);
    return (
        !!currentMapCenterLat &&
        !!currentMapCenterLng &&
        currentMapCenterLat === actualLat &&
        currentMapCenterLng === actualLng
    );
};

const isMapZoomAt = (mapView?: MapView, actualZoom?: number): boolean => {
    if (!mapView || !actualZoom) {
        return false;
    }
    return mapView.zoom === actualZoom;
};

const queryGraphic = async (
    mapView?: MapView,
    entityId?: number,
    entityType?: keyof typeof EsriMapEntityTypeEnum
) => {
    if (!mapView || !entityId || !entityType) {
        return;
    }
    const layerKey =
        ENTITY_TYPE_TO_FEATURE_LAYER_KEY_MAP[
            entityType as keyof typeof ENTITY_TYPE_TO_FEATURE_LAYER_KEY_MAP
        ];
    if (layerKey) {
        const featureLayer = mapView.map.findLayerById(layerKey) as FeatureLayer;
        if (featureLayer) {
            const query = featureLayer.createQuery();
            query.where = `entityId = ${entityId}`;
            query.returnGeometry = true; // Set to true if you need geometry

            const result = await featureLayer.queryFeatures(query);
            return result.features?.[0];
        }
    }
    return;
};

const getGraphicAttribute = (graphic?: Graphic, attributeName?: string) => {
    if (!graphic || !attributeName) {
        return;
    }
    return graphic.attributes[attributeName];
};

const getGraphicLocationGeoPoint = (graphic?: Graphic): GeoPoint | undefined => {
    if (!graphic) {
        return;
    }
    // @ts-expect-error latitude and longitude is not in type Geometry, but it does have these 2 properties
    return { latitude: graphic?.geometry?.latitude, longitude: graphic?.geometry?.longitude };
};

export const mapTestHelpers = {
    isMapCenterAt,
    isMapZoomAt,
    queryGraphic,
    getGraphicAttribute,
    getGraphicLocationGeoPoint,
};
